import { render, staticRenderFns } from "./DetailsDsV2.vue?vue&type=template&id=469cb832&scoped=true&"
import script from "./DetailsDsV2.vue?vue&type=script&lang=js&"
export * from "./DetailsDsV2.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDsV2.vue?vue&type=style&index=0&id=469cb832&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cb832",
  null
  
)

export default component.exports